<template>
  <div>
    <loader-component v-if="isLoading" class="float-center" />
    <div id="tendency" class="m-t-10">
      <form action="#" v-on:submit.prevent="submitForm">
        <div class="form-group" :key="keyTable">
          <table
            class="table table-bordered"
            id="listBarTendencyModal"
            width="100%"
          >
            <thead>
              <tr>
                <th width="2%" class="text-center">No</th>
                <th width="80%" class="text-center">Media</th>
              </tr>
            </thead>
            <tbody class="text-center"></tbody>
          </table>
        </div>
        <div class="form-group">
          <pagination-component
            v-if="page_info != null"
            :key="pagination_key"
            class="pull-left"
            :data="page_info"
            :goto="true"
          />
        </div>
        <div class="form-group" align="right">
          <button
            type="button"
            class="btn btn-danger m-r-5"
            data-dismiss="modal"
          >
            Tutup
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import pagintaion_component from "@/views/components/pagination.vue";
import loader_component from "@/views/components/loader.vue";

$.pgNotification = notif;

export default {
  name: "mdal_tendency",
  components: {
    "pagination-component": pagintaion_component,
    "loader-component": loader_component,
  },
  props: {
    data: Object,
  },
  data() {
    return {
      id_project: this.$store.getters.user.id_project,
      category: this.data.category,
      dataTendency: {},
      page_info: null,
      pagination_key: 0,
      dataStream: [],
      keyTable: 10,
      isLoading: true,
    };
  },
  methods: {
    getData: function () {
      let self = this;
      let api = process.env.VUE_APP_API_URL + "tendency/bar/" + this.id_project;
      this.$http.get(api).then((response) => {
        if (response.status == 204) {
          self.dataTendency = {};
          self.page_info = null;
        } else {
          this.isLoading = false;
          self.table.clear().draw();
          self.dataTendency = this.data.data.acc[this.category];
          for (let index in self.dataTendency) {
            let no = index;
            let media = self.dataTendency[index].account;
            self.table.row.add([no, media]).node().id = index;
            self.table.columns.adjust().draw();
          }
          if (this.isLoading) {
            $("#tendency").hide();
          } else {
            $("#tendency").show();
          }
        }
      });
    },
  },
  created() {
    this.table = $("#listBarTendencyModal").DataTable();
  },
  mounted() {
    this.getData();
    this.table = $("#listBarTendencyModal").DataTable();
    if (this.isLoading) {
      $("#tendency").hide();
    } else {
      $("#tendency").show();
    }
  },
};
</script>

<style scoped>
.form-control {
  -webkit-appearance: button;
}
select {
  cursor: pointer;
}
</style>